var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgHomeIconLarge(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24 10l2-2 2 2v3.667l4 1.833 1 1.5h-1.5L20 12 8.5 17H7l1-1.5L20 10l4 1.833V10zm-14 8l10-4 10 4v14h-7V21h-6v11h-7V18z",
    fill: "#fff"
  })));
}

export default SvgHomeIconLarge;